import { useCallback } from "react";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";

// Sends the admin to login with a message, and back to the current page (or callbackUrl) after login
const useAdminLoginRedirect = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const toAdminLogin = useCallback((message: string, callbackUrl?: string) => {
        const searchParams = {
            callbackUrl: callbackUrl ?? (location.pathname + location.search),
            message
        };
        navigate({
            pathname: '/admin/login',
            search: `?${createSearchParams(searchParams)}`
        });
    }, [navigate, location]);

    return [toAdminLogin];
};

export default useAdminLoginRedirect;
